import DocumentsList from "./documents-list";

export default DocumentsList;
